var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"--with-icon",attrs:{"text":_vm.text,"small":_vm.small},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [(_vm.icon)?_c('v-icon',{staticClass:"mr-3",attrs:{"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }